export default __webpack_public_path__ + "static/Pala_13-d9df4892046e2808ccca0db541597b14.png";